module.exports = __webpack_public_path__ + "fonts/ProximaNova-BoldIt.woff2";